import { Accordion, AccordionDetails, AccordionSummary, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { IS_MOBILE } from "../../../constants/breakpoints";
import { Add, ArrowDown2 } from "iconsax-react";
import { useTranslation } from "react-i18next";
import { BaseButton } from "../base-button/base-button";
import BaseDialog from "../base-dialog/base-dialog";

function BaseFilter({ children, open, setOpen, handleSubmitFilter, resetFilters, activeFilterCount, top }) {
    const { t } = useTranslation();
    const { isItinerary } = JSON.parse(sessionStorage.getItem("generalInformation")) || {};

    return (
        <>
            {IS_MOBILE ? (
                <BaseDialog open={open} handleClose={() => setOpen(false)} top={top}>
                    <DialogTitle display="flex" columnGap={1} alignItems="center">
                        <Add className="close" size="32" color="var(--teal-color-18)" onClick={() => setOpen(false)} cursor="pointer" />
                        <span>
                            {activeFilterCount} {t("filter")}
                        </span>
                        <span
                            className={`base-filter__cancel-filter ${!activeFilterCount && "disable"}`}
                            onClick={activeFilterCount > 0 ? resetFilters : undefined}
                        >
                            {t("cancelFilter")}
                        </span>
                    </DialogTitle>
                    <DialogContent dividers={true}>{children}</DialogContent>
                    <DialogActions>
                        <BaseButton
                            text={t("General.Apply Filter")}
                            color="primary"
                            size="medium"
                            radius="radius-10"
                            handleClick={handleSubmitFilter}
                        />
                    </DialogActions>
                </BaseDialog>
            ) : (
                <Grid className="base-filter" container item xs={12} sx={{ maxHeight: isItinerary ? "calc(100vh - 12rem)" : "fit-content" }}>
                    <Accordion defaultExpanded sx={{ width: "100%", boxShadow: { xs: "none", md: "0px 0px 3px 0px rgba(0, 0, 0, 0.25)" } }}>
                        <AccordionSummary className="base-filter__title" expandIcon={<ArrowDown2 color="var(--light-color)" />}>
                            <Grid container item xs="auto" columnGap={2} justifyContent="space-between" alignItems="center">
                                <Grid component="span" container item xs="auto">
                                    {activeFilterCount} {t("filter")}
                                </Grid>
                                <Grid
                                    className={`base-filter__cancel-filter ${!activeFilterCount && "disable"}`}
                                    component="span"
                                    container
                                    item
                                    xs="auto"
                                    onClick={activeFilterCount > 0 ? resetFilters : undefined}
                                >
                                    {t("cancelFilter")}
                                </Grid>
                            </Grid>
                        </AccordionSummary>

                        <AccordionDetails className="base-filter__drop-down">{children}</AccordionDetails>
                    </Accordion>
                </Grid>
            )}
        </>
    );
}

export default BaseFilter;
